module.exports = __webpack_public_path__ + "static/media/logo-colour.777d7105.svg";